module.exports = __webpack_public_path__ + "static/img/LinkedIn Franklin.70e45ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/LinkedIn Franklin.jpg
// module id = AFZx
// module chunks = 1